export default "__VITE_ASSET__7Pd9eCc1__"